// apps/web/src/lib/dashboards.ts
// Single source of truth for the dashboard catalog. Consumed by:
//   · apps/web/src/pages/landing.tsx     — renders 1 card per entry
//   · apps/web/src/primitives/DashSelector.tsx — renders 1 row per
//     OTHER entry (filters out `current`)
//
// Adding a new dashboard ⇒ ONE edit here + the route in router/routes.tsx.
// Both the landing TOC and the in-banner DashSelector picks it up
// automatically.

export type DashRoute =
  | '/brief'
  | '/crypto'
  | '/signal-history'
  | '/operations'
  | '/oracle';

export type DashId =
  | 'brief'
  | 'crypto'
  | 'signal-history'
  | 'operations'
  | 'oracle';

export interface Dashboard {
  readonly id:          DashId;
  readonly to:          DashRoute;
  readonly icon:        string;
  readonly label:       string;
  readonly description: string;
}

// Ordering is the canonical display order for both consumers.
export const DASHBOARDS: ReadonlyArray<Dashboard> = [
  {
    id:          'brief',
    to:          '/brief',
    icon:        '◆',
    label:       'Daily Brief',
    description: 'Daily macro brief — thesis, signals, basket, risk posture',
  },
  {
    id:          'crypto',
    to:          '/crypto',
    icon:        '◇',
    label:       'Crypto',
    description: 'Account holdings & value · Uniswap V3 LP positions (fees, IL, PnL) · liquidity analysis',
  },
  {
    id:          'signal-history',
    to:          '/signal-history',
    icon:        '◷',
    label:       'Signal History',
    description: 'Per-ticker signal history grid + drill panel',
  },
  {
    id:          'operations',
    to:          '/operations',
    icon:        '⚠',
    label:       'Operations',
    description: 'Health · costs · invariants · calibration',
  },
  {
    id:          'oracle',
    to:          '/oracle',
    icon:        '◎',
    label:       'Data Oracle',
    description: 'Multi-source price consensus · per-source health · legacy-vs-oracle divergence',
  },
];
